import React from 'react';
const ArticleIcon = ({ fill, width, height, opacity }) => (
    <svg width={width} height={height} viewBox="0 0 534.754 534.754">
        <g opacity={opacity} fill={fill}>
            <path d="M483 0H52C23 0 0 23 0 52v431c0 28 23 52 52 52h431c28 0 52-24 52-52V52c0-29-24-52-52-52zm9 483c0 5-4 9-9 9H52c-5 0-9-4-9-9V112h449v371z" />
            <path d="M204 213h207a25 25 0 0 0 0-49H204a25 25 0 0 0 0 49zM204 293h207a25 25 0 0 0 0-49H204a25 25 0 0 0 0 49zM204 372h207a25 25 0 0 0 0-49H204a25 25 0 0 0 0 49zM204 457h207a25 25 0 0 0 0-50H204a25 25 0 0 0 0 50zM124 213a25 25 0 1 0 0-49 25 25 0 0 0 0 49zM124 293a25 25 0 1 0 0-50 25 25 0 0 0 0 50zM124 372a25 25 0 1 0 0-49 25 25 0 0 0 0 49zM124 457a25 25 0 1 0 0-50 25 25 0 0 0 0 50z" />
        </g>
    </svg>
);

export default ArticleIcon;
